import type * as Types from '@xingternal/pages-graphql-types';

import * as Operations from './LocationsQuery.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LocationsQueryVariables = Types.Exact<{
  id: Types.Scalars['SlugOrID']['input'];
}>;


export type LocationsQuery = (
  { __typename?: 'Query' }
  & { viewer?: Types.Maybe<(
    { __typename?: 'Viewer' }
    & Pick<Types.Viewer, 'id'>
    & { xingId?: Types.Maybe<(
      { __typename?: 'XingId' }
      & Pick<Types.XingId, 'id'>
    )> }
  )>, entityPageLocations?: Types.Maybe<(
    { __typename?: 'EntityPageLocations' }
    & { collection: Array<(
      { __typename?: 'EntityPageLocation' }
      & Pick<Types.EntityPageLocation, 'id' | 'label' | 'city' | 'address' | 'addressSuffix' | 'postcode' | 'email' | 'websiteURL' | 'highlighted'>
      & { coordinates?: Types.Maybe<(
        { __typename?: 'GPSCoordinates' }
        & Pick<Types.GpsCoordinates, 'latitude' | 'longitude'>
      )>, country?: Types.Maybe<(
        { __typename?: 'Country' }
        & Pick<Types.Country, 'countryCode' | 'localizationValue' | 'localizationKey'>
      )>, phoneNumber?: Types.Maybe<(
        { __typename?: 'EntityPagePhoneNumber' }
        & Pick<Types.EntityPagePhoneNumber, 'number' | 'countryCode'>
      )>, faxNumber?: Types.Maybe<(
        { __typename?: 'EntityPagePhoneNumber' }
        & Pick<Types.EntityPagePhoneNumber, 'number' | 'countryCode'>
      )> }
    )> }
  )> }
);



/**
 * __useLocationsQuery__
 *
 * To run a query within a React component, call `useLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLocationsQuery(baseOptions: Apollo.QueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationsQuery, LocationsQueryVariables>(Operations.Locations, options);
      }
export function useLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationsQuery, LocationsQueryVariables>(Operations.Locations, options);
        }
export type LocationsQueryHookResult = ReturnType<typeof useLocationsQuery>;
export type LocationsLazyQueryHookResult = ReturnType<typeof useLocationsLazyQuery>;
export type LocationsQueryResult = Apollo.QueryResult<LocationsQuery, LocationsQueryVariables>;